import { useEffect } from 'react';

import { freshchatService } from '../../services';

import { UseFreshchat } from './types';

export const useFreshchat = (props: UseFreshchat) => {
  const {
    restoreId,
    restoreIdsLoading,
    hideChatButton,
    externalId,
    setRestoreId,
  } = props;

  useEffect(() => {
    if (restoreIdsLoading) {
      return;
    }

    freshchatService.init({
      restoreId: restoreId,
      externalId: externalId,
      setRestoreId: setRestoreId,
      hideChatButton: hideChatButton,
    });
  }, [restoreId, restoreIdsLoading, hideChatButton, externalId]);

  return null;
};
